import React, { FC } from 'react';
import clsx from 'clsx';

import BackToWebsite from 'components/BackToWebsite';
import { PhoneNumbersLabels } from 'enums/PhoneNumbers';
import { ReactComponent as ChatIcon } from 'images/chat-icon.svg';
import { ReactComponent as EmailIcon } from 'images/email-icon.svg';

import styles from './Contact.module.scss';

export enum ContactEmail {
  Support = 'support@planneryapp.com',
  OutOfState = 'outofstate@planneryapp.com',
}

interface ContactProps {
  handleGetBack?: () => void;
  showBackButton?: boolean;
  className?: string;
  isHorizontalCard?: boolean;
  email?: ContactEmail;
}

const Contact: FC<ContactProps> = ({
  handleGetBack,
  showBackButton = true,
  className,
  isHorizontalCard = false,
  email = ContactEmail.Support,
}) => (
  <>
    <div className={clsx(styles.contactsContainer, className)}>
      <a
        href={`sms:${PhoneNumbersLabels.Support}`}
        className={clsx(styles.contactItemContainer, isHorizontalCard && styles.horizontalContactItem)}
      >
        <ChatIcon />
        <div>
          <p className={clsx(styles.contactsTitle, isHorizontalCard && styles.horizontalContactsTitle)}>
            Text or call us
          </p>
          <p className={clsx(styles.contactsPhoneNumber, styles.purpleText)}>{PhoneNumbersLabels.Support}</p>
        </div>
      </a>
      <a
        href={`mailto:${email}`}
        className={clsx(styles.contactItemContainer, isHorizontalCard && styles.horizontalContactItem)}
      >
        <EmailIcon />
        <div>
          <p
            className={clsx(
              styles.contactsTitle,
              styles.purpleText,
              isHorizontalCard && styles.horizontalContactsTitle,
            )}
          >
            Email us
          </p>
          <p className={styles.contactsSubtitle}>Typically respond within 24-48 hours</p>
        </div>
      </a>
    </div>
    {showBackButton && <BackToWebsite onClick={handleGetBack} className={styles.button} />}
  </>
);

export default Contact;
